import React, { useRef } from 'react';
import { usePrevious } from './usePrevious';

export const useIsFirstRenderRef = (): React.MutableRefObject<boolean> => {
  const isFirstRenderRef = useRef(true);
  const prevIsFirstRender = usePrevious(isFirstRenderRef.current);

  if (prevIsFirstRender) {
    isFirstRenderRef.current = false;
  }

  return isFirstRenderRef;
};

export const useIsFirstRender = (): boolean => {
  return useIsFirstRenderRef().current;
};
